import { Fragment, useEffect, useState } from "react";

import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { MegaMenu } from "primereact/megamenu";
import { Row } from "primereact/row";

import { InvoiceService } from "../../hoa-don/InvoiceService";
import { ConfigReportService } from "../ConfigReportService";
import { InvoiceDetailReportService as Service } from "./InvoiceDetailReportService";

import { FormatDisplay } from "../../../shared/format";
import { useDataTable } from "../../../shared/hooks/DataTable";
import EventEmitter from "../../../utils/EventEmitter";
import { DialogSendEmail } from "../../hoa-don/component/DialogSendEmail";
import { DialogView } from "../../hoa-don/component/DialogView";

import cookie from "cookiejs";
import {
  createJob,
  ERROR,
  getCurrentJob,
  getDetailJobById,
  IN_PROGRESS,
  INVOICE_DETAIL_REPORT,
  loginJob,
  SUCCESS,
} from "../../../service/ExportService";
import { AppStorage } from "../../../service/UserStorage";
import { ConfigColumns } from "../../../shared/component/ConfigColumns";
import { FilterDetail } from "../filter-detail";
import { checkLoginRequired } from "../../../utils/helperExportExcel";
import { ToastService } from "../../../AppToast";
import { useDialogExportContext } from "../../context/DialogExportContext";

export default function ChiTietHoaDon() {
  const [displayFilter, setDisplayFilter] = useState(null);
  const [invoiceForm, setInvoiceForm] = useState(null);
  const [invoiceStatus, setInvoiceStatus] = useState(0);
  const [requiredParams, setRequiredParams] = useState(null);

  const [displayView, setDisplayView] = useState(false);
  const [displaySendEmail, setDisplaySendEmail] = useState(false);
  const [displayCancel, setDisplayCancel] = useState(false);
  const [isTableEmpty, setIsTableEmpty] = useState(true);

  const [columns, setColumns] = useState([]);
  const [columnsState, setColumnsState] = useState(0);
  const [footerColumnGroup, setFooterColumnGroup] = useState(null);

  const { setVisible, setStatus, setJobDetail, setMinimize, status } = useDialogExportContext();

  const [summary, setSummary] = useState(null);

  useEffect(() => {
    let hasSumCol = columns?.filter((column) => column.sum?.trim())?.length > 0;
    if (hasSumCol) {
      setFooterColumnGroup(
        <ColumnGroup>
          <Row>
            <Column style={{ minWidth: "40px", maxWidth: "40px", border: 0 }} />
            {columns.map((_column, index) => {
              if (_column.sum) {
                return (
                  <Column
                    key={index}
                    footer={FormatDisplay.number(
                      summary ? summary[_column.sum] : 0
                    )}
                    style={{
                      justifyContent: "end",
                      minWidth: `${_column.width}px`,
                      maxWidth: `${_column.width}px`,
                    }}
                  />
                );
              }
              return (
                <Column
                  key={index}
                  style={{
                    minWidth: `${_column.width}px`,
                    maxWidth: `${_column.width}px`,
                    border: 0,
                    borderLeft: "1px solid #dee2e6",
                  }}
                />
              );
            })}
          </Row>
        </ColumnGroup>
      );
    } else {
      setFooterColumnGroup(null);
    }
  }, [columns, summary]);

  const downloadExcel = () => {
    Service.downloadExcel(requiredParams).then((data) => {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `bao-cao-chi-tiet-hoa-don.xlsx`;
      link.click();
    });
  };

  const downloadGroupExcel = () => {
    Service.downloadGroupExcel({
      ...requiredParams,
      userName: AppStorage.get("UserName"),
    }).then((data) => {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `bao-cao-nhom-theo-hoa-don.xlsx`;
      link.click();
    });
  };

  useEffect(() => {
    const showDialogSendEmail = (dataInvoice) => {
      setSelectedItems(dataInvoice);
      setDisplaySendEmail(true);
    };
    const eventsshowDialogSendEmail = EventEmitter.addListener(
      "showDialogSendEmail",
      showDialogSendEmail
    );
    return () => {
      eventsshowDialogSendEmail.removeListener(
        "showDialogSendEmail",
        showDialogSendEmail
      );
    };
  });

  const send = (item) => {
    setSelectedItems(item);
    setDisplayView(true);
  };
  const search = (params) => {
    params.userName = AppStorage.get("UserName");
    setRequiredParams(params);
    setDisplayFilter(false);

    Service.getSummary(params).then((data) => {
      setSummary(data);
    });
  };

  const TENNANT_ID = localStorage.getItem("iam-m-invoice-react.v1.0.0_tenant");
  const getDetailJobRunning = async (id: string) => {
    if (!id || !TENNANT_ID) return;
    const res = await getDetailJobById(id);
    setJobDetail(res);
    const isExpired = res.expiredTime && new Date(res.expiredTime) < new Date();

    if (res.status === IN_PROGRESS && isExpired) {
      setStatus("error");
      setVisible(true);
      return;
    }

    if (res.status === IN_PROGRESS) {
      setStatus("doing");
      setVisible(true);
      setTimeout(() => {
        getDetailJobRunning(id);
      }, 3000);
    }

    if (res.status === SUCCESS) {
      setStatus("success");
      setVisible(true);
    }
    if (res.status === ERROR) {
      setStatus("error");
      setVisible(true);
    }
  };

  const actions = [
    {
      label: "Lọc dữ liệu",
      icon: "pi pi-fw pi-filter",
      className: "iam-toolbar iam-toolbar-secondary",
      command: () => setDisplayFilter(true),
    },
    // {label: 'Xem in PDF', icon: 'pi pi-fw pi-file-pdf', className: 'iam-toolbar iam-toolbar-secondary', command: downloadPdf},
    // {
    //   label: "Kết xuất excel",
    //   icon: "pi pi-fw pi-file-excel",
    //   className: "iam-toolbar iam-toolbar-secondary",
    //   command: downloadExcel,
    // },
    {
      label: "Kết xuất excel",
      icon: "pi pi-fw pi-file-excel",
      className: "iam-toolbar iam-toolbar-secondary",
      disabled: isTableEmpty,
      command: async () => {
        const accessToken = cookie.get("access_token_report");
        const refreshExpiredAtString = cookie.get("refreshExpiredAt");

        const isLoginRequired = checkLoginRequired(
          accessToken,
          refreshExpiredAtString
        );

        if (isLoginRequired) {
          await loginJob();
        }
        let resCurrent = await getCurrentJob();

        const runningJobs = resCurrent.filter(
          (job: any) => job.status === IN_PROGRESS
        );
        if (status === "doing") {
          return ToastService.error("Đang có tiến trình kết xuất khác. Vui lòng đợi.");
        }
        if (runningJobs?.length === 0) {
          await createJob(INVOICE_DETAIL_REPORT, requiredParams);
          setJobDetail(null);
          setVisible(true);
          resCurrent = await getCurrentJob();
        } else {
          return ToastService.error("Đang có tiến trình kết xuất khác. Vui lòng đợi.");
        }

        if (resCurrent.length === 0) {
          setStatus("doing");
          return;
        }

        const jobToTrack = resCurrent.find((job: any) => job.status === IN_PROGRESS) || resCurrent[0];
        setJobDetail(jobToTrack);

        const res = await getDetailJobById(jobToTrack?.jobId!);
        localStorage.setItem("jobIdRunning", jobToTrack?.jobId!);

        switch (res.status) {
          case IN_PROGRESS:
            setStatus("doing");
            break;
          case SUCCESS:
            setStatus("success");
            break;
          case ERROR:
            setStatus("error");
            break;
        }

        if (res.status === SUCCESS) {
          setJobDetail(res);
        }

        if (res.status === IN_PROGRESS) {
          setMinimize(false);
          getDetailJobRunning(jobToTrack?.jobId!);
        }

        setVisible(true);
      },
    },
    {
      label: "Kết xuất excel (Nhóm theo mặt hàng) ",
      icon: "pi pi-fw pi-file-excel",
      className: "iam-toolbar iam-toolbar-secondary",
      command: downloadGroupExcel,
    },
  ];

  const {
    render: renderDataTable,
    selectedItems,
    setSelectedItems,
  } = useDataTable({
    columns,
    columnsState,
    indexColumnWidth: 40,
    getList(params: any): Promise<any> {
      return Service.getList(params).then((res) => {
        setIsTableEmpty(!res?.items || res?.items?.length === 0);
        return res;
      });
    },
    footerColumnGroup,
    requiredParams,
  });

  const hardColumns = {
    invoiceNumber: {
      dataType: "custom",
      customCell(rowData: any): any {
        return (
          <span
            className={`underline send-tax-status send-tax-status-3`}
            onClick={() => send(rowData)}
          >
            {rowData.invoiceNumber}
          </span>
        );
      },
    },
    invoiceStatus: {
      filterType: "multiselect",
      filterOptions: InvoiceService.invoiceStatuses,
      dataType: "custom",
      customCell(rowData: any): any {
        return (
          <span
            className={`invoice-status invoice-status-${rowData.invoiceStatus}`}
          >
            {InvoiceService.invoiceStatuses[rowData.invoiceStatus]?.label}
          </span>
        );
      },
    },
    sendTaxStatus: {
      filterType: "multiselect",
      filterOptions: InvoiceService.sendTaxStatuses,
      dataType: "custom",
      customCell(rowData: any): any {
        if ([3, 4, 5].includes(rowData.sendTaxStatus)) {
          return (
            <span
              className={`underline send-tax-status send-tax-status-${rowData.sendTaxStatus}`}
            >
              {InvoiceService.sendTaxStatuses[rowData.sendTaxStatus]?.label}
            </span>
          );
        }
        return (
          <span
            className={`send-tax-status send-tax-status-${rowData.sendTaxStatus}`}
          >
            {InvoiceService.sendTaxStatuses[rowData.sendTaxStatus]?.label}
          </span>
        );
      },
    },
    buyerLegalName: {
      minWidth: 250,
      dataType: "custom",
      customCell(rowData: any): any {
        return rowData.buyerLegalName || rowData.buyerDisplayName;
      },
    },
    sendEmail: { filterType: "boolean", dataType: "boolean" },
  };

  const getConfig = () => {
    return ConfigReportService.get("invoicedetail").then(({ items }) => items);
  };

  const setConfig = (items) => {
    return ConfigReportService.set("invoicedetail", items);
  };

  const restoreConfig = () => {
    return ConfigReportService.restore("invoicedetail");
  };

  return (
    <Fragment>
      <MegaMenu
        model={actions}
        end={
          <ConfigColumns
            hardColumns={hardColumns}
            get={getConfig}
            set={setConfig}
            restore={restoreConfig}
            setColumns={setColumns}
            setColumnsState={setColumnsState}
          />
        }
      />
      <FilterDetail
        header="Báo cáo chi tiết hóa đơn"
        display={displayFilter}
        setDisplay={setDisplayFilter}
        search={search}
        invoiceForm={invoiceForm}
      />
      {renderDataTable()}
      <DialogView
        display={displayView}
        setDisplay={setDisplayView}
        selectedItem={selectedItems}
        setDisplayCancel={setDisplayCancel}
        setInvoiceStatus={setInvoiceStatus}
      />
      <DialogSendEmail
        display={displaySendEmail}
        setDisplay={setDisplaySendEmail}
        selectedItems={selectedItems}
      />
    </Fragment>
  );
}
function setVisible(arg0: boolean) {
  throw new Error("Function not implemented.");
}
